import React, { useState, useEffect, useRef } from 'react'
import { Card, Modal, Row, Col } from 'react-bootstrap'
import Button from 'react-bootstrap/Button'
import { Formik, Form } from 'formik'
import { connect } from 'react-redux'
import Menssage from '../../components/common/mensage'
import { InputTextAreaComponent, LoadingComponent } from 'recupero-comunes'
import {
  cleanStateAssignated,
  postAssigantedResponsable,
  getCBNotificaSiniestro
} from '../../store/actions'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'

import Select from '../../utils/select'

const FormAsignatedResponsable = ({
  show,
  handleClose,
  data,
  form,
  modeAssignated,
  caso,
  user,
  onPostAssignatedResponsability,
  onCleanState,
  dataApi,
  areaTrabajo,
  respSolicitudAseg,
  onGetCBNotificaSiniestro
}) => {
  const initialValues = {
    idOrganizacion: caso.Compania,
    idCaso: caso.IdCaso,
    siniestro: caso.Siniestro,
    siniestroIM: 28775771,
    patente: caso.Patente,
    patenteIM: '',
    tipoGestion: caso.IdTipoGestion,
    idResponsable: data.idResponsable,
    responsable: data.nombre,
    modoAsignacion: modeAssignated,
    observacion: '',
    respSolicitudAseg:respSolicitudAseg.id,
    idUsuario: user, 
    cbNotificaSiniestro: ''
  }
  const history = useNavigate()
  const [showMenssage, setShowMenssage] = useState(false)
  const handleCloseMenssage = () => setShowMenssage(false)
  const [formValues, setFormValues] = useState({})
  const [loading, setLoading] = useState(false)

  const onSubmit = (values) => {
    setShowMenssage(true)
    setFormValues(values)
  }
  const queryState=JSON.parse(localStorage.getItem('filtrosAreaGestion'))
  const onBack = () => {
    onCleanState()
    history('/area-gestion-compania', {
      state: {queryState}
    })
  }

  const onSubmitModal = async () => {
    setShowMenssage(false)
    await setLoading(true)
    try {
      await onPostAssignatedResponsability(formValues)
    } catch (error) {
      toast.error(error)
    } finally {
      await setLoading(false)
      handleClose()
      onBack()
    }
  }

  useEffect(() => {
    if (dataApi.response) {
      toast(dataApi.response)
      dataApi.response = null
    }
    onGetCBNotificaSiniestro({
      concepto: '264'
    })
  }, [dataApi.response])

  const selects = ['cbNotificaSiniestro']
  const refs = useRef(selects.map(() => React.createRef()))

  return (
    <Modal
      className='d-flex  align-items-center justify-content-center square border border-4 '
      show={show}
      onHide={handleClose}
      size='xl'
    >
      <LoadingComponent show={loading || dataApi.loading} />
      <Modal.Header
        className='square border border-5 z-index-1'
        style={{ background: '#4F517A', color: 'white' }}
        as='h5'
      >
        {form['asigcaso-modal-title']}  {respSolicitudAseg && respSolicitudAseg.nombre ? ( 'Monitoreo' ) : '' }
      </Modal.Header>
      <Modal.Body className='square border border-0 m-2'>
        <Formik initialValues={initialValues} onSubmit={onSubmit}>
          {({ values }) => (
            <Form>
              <div>
                <Row>
                  <Col md='12'>
                    <Row className='mt-1'>
                      <Col md='3'>
                        <div className='col'>
                          <dt className='text-sm font-large text-gray-500'>
                            {form['asigcaso-modal-idrespon']}
                          </dt>
                          <dd className='mt-1 text-sm text-gray-900 ml-5'>
                            {data.idResponsable}
                          </dd>
                        </div>
                      </Col>
                      <Col md='3'>
                        <div className='col'>
                          <dt className='text-sm font-medium text-gray-500'>
                            {form['asigcaso-modal-nombrerespon']}
                          </dt>
                          <dd className='mt-1 text-sm text-gray-900 ml-5'>
                            {data.nombre}
                          </dd>
                        </div>
                      </Col>
                      {respSolicitudAseg && respSolicitudAseg.nombre ? (
                      <Col md='3'>
                        <div className='col'>
                          <dt className='text-sm font-medium text-gray-500'>
                            {form['asigcaso-lbl-solasegurado']}
                          </dt>
                          <dd className='mt-1 text-sm text-gray-900 ml-5'>
                            {respSolicitudAseg.nombre}
                          </dd>
                        </div>
                      </Col>
                      ) : null }
                    </Row>
                    <br></br>
                    {caso.IdTipoGestion == 207002 ? (
                    <Row>
                      <Col md='5'>
                        <dt className='text-sm font-medium text-gray-500'>Notifica Siniestro con Proceso</dt>
                        <Select
                          ref={refs.current[selects.indexOf('cbNotificaSiniestro')]}
                          name='cbNotificaSiniestro'
                          label=''
                          labelKey='nombre'
                          options={dataApi.cbNotificaSiniestro}
                        />                                              
                      </Col>
                    </Row>
                    ) : null }
                  </Col>
                  <Col md='12' className='mt-4'>
                    <InputTextAreaComponent
                      name='observacion'
                      type='text'
                      label={form['asigcaso-modal-complemento']}
                    />
                  </Col>
                </Row>
              </div>
              <Card.Body>
                <div
                  className='d-grid gap-2 d-md-block float-left mt-4 mb-2'
                  style={{
                    float: 'right'
                  }}
                >
                  <Button 
                   className='m-2 w-auto'
                   variant='outline-info'
                   onClick={handleClose}>
                    {form['asigcaso-modal-btn-cancelar']}
                  </Button>
                  <Button
                    type='onSubmit'
                    className='btn btn-danger m-1 btn-xl'
                    variant='confirmar'
                  >
                    {form['asigcaso-modal-btn-confirmar']}
                  </Button>
                </div>
              </Card.Body>
              {showMenssage && (
                <Menssage
                  show={showMenssage}
                  handleClose={handleCloseMenssage}
                  message={form['asigcaso-modal-title']}
                  onSubmitModal={() => onSubmitModal()}
                />
              )}
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  )
}
const mapStateToProps = (state) => ({
  dataApi: state.assignated
})

const mapDispatchToProps = (dispatch) => ({
  onPostAssignatedResponsability: (body) =>
  dispatch(postAssigantedResponsable(body)),
  onCleanState: () => dispatch(cleanStateAssignated()),
  onGetCBNotificaSiniestro: (query) => dispatch(getCBNotificaSiniestro(query))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FormAsignatedResponsable)
